var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@1xWater Level") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Water-Level",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 5.5,
    x2: 1.5,
    y2: 5.5,
    id: "Line",
    stroke: "#979797",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,6.19416756 C3.60887811,7.77652808 5.70462464,8.56770833 7.78723958,8.56770833 C9.86985453,8.56770833 12.1177921,7.77652808 14.5310524,6.19416756 C16.8895205,4.42713572 19.0396881,3.54361979 20.9815553,3.54361979 C22.9234225,3.54361979 25.0962374,4.42713572 27.5,6.19416756",
    id: "Line-2",
    stroke: "#1991DC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,14.1941676 C3.94894037,15.7651565 6.21471803,16.550651 8.29733297,16.550651 C10.3799479,16.550651 12.4578544,15.7651565 14.5310524,14.1941676 C16.8895205,12.4271357 19.0396881,11.5436198 20.9815553,11.5436198 C22.9234225,11.5436198 25.0962374,12.4271357 27.5,14.1941676",
    id: "Line-2",
    stroke: "#1991DC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,22.1941676 C3.94894037,23.7651565 6.21471803,24.550651 8.29733297,24.550651 C10.3799479,24.550651 12.4578544,23.7651565 14.5310524,22.1941676 C16.8895205,20.4271357 19.0396881,19.5436198 20.9815553,19.5436198 C22.9234225,19.5436198 25.0962374,20.4271357 27.5,22.1941676",
    id: "Line-2",
    stroke: "#1991DC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage);
export default __webpack_public_path__ + "static/media/Stage.7ac3e2823e8401896f4b0026862ef17f.svg";
export { ForwardRef as ReactComponent };